/*eslint no-unused-vars: [0]*/
import {
	ADD_PRODUCT_TO_CART,
	REMOVE_PRODUCT_FROM_CART,
	SET_QUANTITY,
	OPEN_CART_LIST_DRAWER,
	CLOSE_CART_LIST_DRAWER,
	FETCH_CART_SUCCESS,
	UPDATE_ORDER,
	UPDATE_ORDER_SUCCESS,
	UPDATE_ORDER_FAIL,
	CLEAR_CART,
	CHECKOUT_REQUEST,
	CHECKOUT_SUCCESS
}  from "../constants/ActionTypes";

const initialState = {
	products: [],
	addedProducts: [],
	addedIds: [],
  	quantityById: {},
	totalProductCount: 0,
	totalPrice: 0,
	checkoutStatus: {
		checkoutPending: false,
		error: null,
	},
	orderID: null,
	cartListDrawerOpened: false,
	order: {
		orderRows: []
	},
	loading: true,
	error: null,
	checkoutSuccess: false
};

const getOrderRowQuantities = orderRows => {
	let quantityById = {};
	for ( let i = 0; i < orderRows.length; i++ ) {
		quantityById[orderRows[i].productID] = orderRows[i].productCount;
	}
	return quantityById;
};

export default function (state = initialState, action) {
    switch (action.type) {
		case ADD_PRODUCT_TO_CART:
			return {
				...state,
				cartListDrawerOpened: true,
				loading: true
			};
		case UPDATE_ORDER:
			return {
				...state,
				loading: true
			};
		case UPDATE_ORDER_SUCCESS:
			return {
				...state,
				order: {...action.payload.order},
				orderID: action.payload.orderID,
				products: [...action.payload.order.orderRows.map(orderRow => {
						return orderRow.product;
					})
				],
				addedProducts: [...action.payload.order.orderRows.map(orderRow => {
						return { ...orderRow.product, status: orderRow.status };
					})
				],
				quantityById: getOrderRowQuantities(action.payload.order.orderRows),
				loading: false,
				error: false,
				checkoutSuccess: action.payload.checkoutSuccess
			};
		case UPDATE_ORDER_FAIL:
			return {
				...state,
				loading: false,
				error: action.error
			};
		case CHECKOUT_REQUEST:
			return {
				...state,
				checkoutStatus: {
					checkoutPending: true,
					error: null
				}
			};
		case CHECKOUT_SUCCESS:
			return {
				...initialState,
				checkoutStatus: {
					checkoutPending: false,
					error: null
				}
			};
		case SET_QUANTITY:
			return {
				...state,
				loading: true
			};
        case REMOVE_PRODUCT_FROM_CART:
            return {
                ...state,
                order: {
					...state.order/* ,
					orderRows: [...state.order.orderRows.filter(orderRow => orderRow.orderRowID !== action.orderRowID)] */
				},
			};
		case FETCH_CART_SUCCESS:
            return {
                ...state,
				orderID: action.order.orderID,
				order: action.order,
				products: [...action.order.orderRows.map(orderRow => {
					return orderRow.product;
				})
				],
			};
		case OPEN_CART_LIST_DRAWER:
            return {
                ...state,
                cartListDrawerOpened: action.cartListDrawerOpened
            };
		case CLOSE_CART_LIST_DRAWER:
            return {
                ...state,
                cartListDrawerOpened: action.cartListDrawerOpened
			};
		case CLEAR_CART:
			return {
				...initialState,
				loading: false
			}
        default:
            return state
    }
}

export const getAddedIds = state => state.addedId;
export const getQuantity = (state, productId) => state.quantityById[productId] || 0;
export const getProductQuantity = (state, productId)  => state.quantityById[productId] || 0;
